enum ActionTypes {
  CONTACT_US_SUBMIT = 'app/LandingPage/FarmToTable/CONTACT_US_SUBMIT',
  CONTACT_US_SUCCESS = 'app/LandingPage/FarmToTable/CONTACT_US_SUCCESS',
  CONTACT_US_FAILURE = 'app/LandingPage/FarmToTable/CONTACT_US_FAILURE',
}

export default ActionTypes;
